<template>
  <div class="schedule-filters">
<!--    <Toggle-->
<!--      v-model="daySchedule"-->
<!--      :items="{-->
<!--        [$t('Filters.options.day')]: true,-->
<!--        [$t('Filters.options.all')]: false,-->
<!--      }"-->
<!--    />-->
    <div v-if="!daySchedule && length" class="info">
      <div class="date hide-mobile">
        <div class="main">{{ date }}</div>
        <div class="extra">{{ dateExtra }}</div>
      </div>
      <!--<div class="counts">{{ counts }}</div>-->
    </div>
    <div class="filter-toggle hide-pc" @click="openFilters">
      <div class="badge round bg primary" v-if="filtersCount">{{ filtersCount }}</div>
      <img src="@/assets/icons/filter.svg" alt="" />
    </div>
    <Paginator
      class="hide-mobile"
      v-if="false && daySchedule"
      :prev="prevDay"
      :next="nextDay"
      @prev="changeDay(false)"
      @next="changeDay(true)"
    />
    <div class="filter-content" :class="{ opened: openedFilters }">
      <SelectCustom
        class="mobile-list last"
        :name="$t('pages.schedule.event-type-filter-label')"
        :list="eventTypesOptions"
        v-model="filters.type"
        is-multiple
      />
      <SelectCustom
        class="mobile-list last"
        :name="$t('Filters.select-name')"
        :list="expertsEvent"
        v-model="filters.user_id"
      />
      <div class="actions hide-pc">
        <button class="primary" @click="closeFilters">{{ $t('close') }}</button>
        <!--<button>Cancel</button>-->
      </div>
    </div>
  </div>
</template>

<script>
import Toggle from '@/components/Toggle'
import moment from 'moment'
import Paginator from '@/components/Paginator'
import SelectCustom from '@/components/form/SelectCustom'
import { mapActions, mapState } from 'vuex'
import { EVENT_TYPES } from '@/utils/_CONST'
import getUsers from '@/mixins/getUsers'
import { cleanObjects } from '@/utils/cleanObjects'

export default {
  name: 'Filters',
  components: { SelectCustom, Paginator, Toggle },
  mixins: [getUsers],
  props: {
    stats: Object,
    interval: Object,
    days: Array,
    length: Number,
  },
  data: () => ({
    filters: {
      type: [],
      course_type: [],
      user_id: [],
    },
  }),
  computed: {
    filtersCount() {
      return Object.values(this.filters).reduce((tmp, list) => tmp + list.length, 0)
    },
    openedFilters() {
      return this.$route.query && this.$route.query.filters
    },
    day() {
      return parseInt(this.$route.params.day)
    },
    date() {
      if (this.daySchedule) {
        return moment(this.day).format('MMM DD')
      } else {
        const start = moment(this.interval?.start).format('MMM DD')
        const end = moment(this.interval?.end).format('DD')
        const year = moment(this.interval.end).format('YYYY')
        return `${start} • ${end}, ${year}`
      }
    },
    dateExtra() {
      if (this.daySchedule) {
        return moment(this.day).format('dddd')
      } else {
        return this.$t('events-count', { count: this.length })
      }
    },
    counts() {
      let s = {
        ...this.stats,
        2: (this.stats[2] || 0) + (this.stats[5] || 0),
      } //Объединияет break(2) и break_open_hours(5)
      delete s[5]
      return Object.keys(s)
        .map((id) => `${s[id]} ${EVENT_TYPES[id]}`)
        .join(' • ')
    },
    daySchedule: {
      get() {
        return !!this.$route.params.day
      },
      set(val) {
        this.$router.push({
          name: this.$route.name,
          params: {
            day: val ? this.daysList[0] : undefined,
          },
        })
      },
    },
    daysList() {
      return Array.from(this.days)
        .map((d) => +d)
        .sort()
    },
    prevDay() {
      return Array.from(this.daysList)
        .reverse()
        .find((date) => date < this.day)
    },
    nextDay() {
      return Array.from(this.daysList).find((date) => date > this.day)
    },
    expertsEvent() {
      const exceptions = [7, 8, 9, 11]
      return this.users.expert
        .filter(({ id }) => !exceptions.includes(id))
        .map(({ id, localized_name, localized_surname }) => ({
          id,
          title: `${localized_name[this.$i18n.locale]} ${localized_surname[this.$i18n.locale]}`,
        }))
    },
    eventTypesOptions() {
      return [
        {
          id: 5,
          title: this.$t('pages.schedule.filters.event-types.discussion'),
        },
        {
          id: 2,
          title: this.$t('pages.schedule.filters.event-types.lecture'),
        },
        {
          id: 1,
          title: this.$t('pages.schedule.filters.event-types.presentation'),
        },
        {
          id: 3,
          title: this.$t('pages.schedule.filters.event-types.qa'),
        },
        {
          id: 4,
          title: this.$t('pages.schedule.filters.event-types.workshop'),
        },
      ]
    },
    ...mapState(['typesEvent']),
  },
  methods: {
    openFilters() {
      window.scroll(0, 0)
      this.$router.push({ query: { filters: 1 } })
    },
    closeFilters() {
      this.$router.go(-1)
    },
    changeDay(next) {
      const day = next ? this.nextDay : this.prevDay
      if (!day) return
      this.$router.push({
        name: this.$route.name,
        params: { day },
      })
    },
    filterType(ids) {
      this.filters.course_type = []
      this.filters.type = []
      for (let id of ids) {
        if (id == -1) this.filters.type = [2, 5]
        else this.filters.course_type.push(id)
      }
    },
    ...mapActions('events', ['getEvents']),
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.getEvents({
          params: {
            filter: cleanObjects(this.filters),
          },
        })
      },
    },
    openedFilters(opened) {
      if (opened) document.body.classList.add('modal-open')
      else document.body.classList.remove('modal-open')
    },
  },
}
</script>

<style lang="scss">
.schedule-filters {
  display: flex;
  padding: 20px;

  @include PC {
    padding: 11px 0 10px;
    margin-bottom: 0;
    bottom: none;
  }

  @include mobile {
    align-items: center;
    margin-top: 0;
    padding-top: 0;
  }

  .toggle-block {
    .item {
      min-width: 54px;
    }
  }

  .info {
    display: flex;
    align-items: center;
    margin-left: 12px;
    width: 100%;
    flex-shrink: 2;

    @include PC {
      width: auto;
      flex-shrink: 0;
      margin: 0 28px;
    }

    .date {
      display: flex;
      flex-direction: column;

      .main {
        font-weight: 700;
        font-size: 15px;
        line-height: 20px;
      }

      .extra {
        font-weight: 700;
        font-size: 12px;
        line-height: 147.5%;
        color: #ccd7e6;
      }
    }

    .counts {
      font-weight: bold;
      font-size: 10px;
      line-height: 12px;
      color: $dark;
    }
  }

  .filter-toggle {
    position: relative;

    @include mobile {
      margin-left: auto;
    }

    .badge {
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(40%, -40%);
      border: 2px solid $bg;
      min-width: 0;
    }
  }

  .filter-content {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    flex-shrink: 3;

    .select-custom {
      margin-left: 10px;

      .list .value {
        margin-left: -9px;
      }

      .list {
        margin-top: 1px;
        width: calc(100% - 2px);
        margin-left: 1px;
      }
    }

    .actions {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 20px;

      > *:first-child:last-child {
        grid-column: 1 / 3;
      }
    }

    @include mobile {
      position: fixed;
      top: 70px;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 30px 20px;
      flex-direction: column;
      justify-content: flex-start;
      background: $white;
      z-index: 99;
      max-height: 100vh;
      overflow: auto;

      &:not(.opened) {
        display: none;
      }
    }

    @include PC {
      .select-custom {
        width: 160px;
        max-width: 50%;

        &:not(.last) {
          margin-right: 7px;
        }
      }
    }
  }
}
</style>
